<template>
  <nx-form :value="value"
           class="nx-scrollytelling-slide-editor-form"
           validation-mode="eager"
           v-on="$listeners"
           ref="form"
           v-slot="{ draft, form }">
    <nx-scrollytelling-slide-configuration-scope :draft="draft"/>
    <nx-form-scope-card title="Multimedia" icon="image" class="mt-1" collapsable>
      <v-layout row wrap>
        <v-flex xs12 md6>
          <nx-form-text
            name="title"
            :label="$t('message.form.fields.title')"
            :value="draft.title"
          />
        </v-flex>
        <v-flex xs12 md3 :class="{ 'pl-3': $vuetify.breakpoint.mdAndUp }">
          <nx-form-color-picker
            name="textColor"
            :label="$t('message.form.fields.textColor')"
            default="000000"
            :value="draft.textColor"
          />
        </v-flex>
        <v-flex xs12 md3 :class="{ 'pl-3': $vuetify.breakpoint.mdAndUp }">
          <nx-form-select
            name="backgroundOpacity"
            :label="$t('message.form.fields.multimediaOpacity')"
            :items="[100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 0]"
            :default="100"
            :value="draft.backgroundOpacity"
          />
        </v-flex>
        <nx-scrollytelling-slide-editor-form-image-field
          desktop-image-name="multimediaDesktopImage"
          mobile-image-name="multimediaMobileImage"
          image-alt-name="multimediaImageAlt"
          :desktop-image-value="draft.multimediaDesktopImage"
          :mobile-image-value="draft.multimediaMobileImage"
          :image-alt-value="draft.multimediaImageAlt"
          required
          @selection="updateOnSelection"
        />
        <v-flex xs12>
          <nx-form-text
            name="signatureAuthorName"
            :label="$t('message.form.fields.signatureAuthorName')"
            :value="draft.signatureAuthorName"
          />
        </v-flex>
        <v-flex md6>
          <nx-form-switch
            name="multimediaFixed"
            :label="$t('message.scrollytelling.fields.multimediaFixed')"
            :default="false"
            :value="draft.multimediaFixed"
          />
        </v-flex>
        <v-flex md6 :class="{ 'pl-3': $vuetify.breakpoint.mdAndUp }">
          <nx-form-switch
            v-if="anyBackgroundIsVideo"
            name="videoLoop"
            :label="$t('message.form.fields.videoLoop')"
            :default="false"
            :value="draft.videoLoop"
          />
        </v-flex>
      </v-layout>
    </nx-form-scope-card>
    <nx-scrollytelling-slide-background-color-scope class="mt-1" :draft="draft" />
  </nx-form>
</template>

<script>
import NxForm from '@/modules/form/Form';
import NxScrollytellingSlideConfigurationScope
  from '@/modules/scrollytelling/components/form/components/ScrollytellingSlideConfigurationScope';
import NxFormScopeCard from '@/modules/form/components/FormScopeCard';
import NxFormSwitch from '@/modules/form/components/FormSwitch';
import NxFormSelect from '@/modules/form/components/FormSelect';
import NxScrollytellingSlideEditorFormImageField
  from '@/modules/scrollytelling/components/form/components/ScrollytellingSlideEditorFormImageField';
import NxFormText from '@/modules/form/components/FormText';
import NxScrollytellingSlideBackgroundColorScope
  from '@/modules/scrollytelling/components/form/components/ScrollytellingSlideBackgroundColorScope';
import NxFormColorPicker from '@/modules/form/components/FormColorPicker';

export default {
  name: 'nx-scrollytelling-slide-editor-form-multimedia',
  components: {
    NxScrollytellingSlideBackgroundColorScope,
    NxFormText,
    NxScrollytellingSlideEditorFormImageField,
    NxFormSelect,
    NxFormSwitch,
    NxFormScopeCard,
    NxScrollytellingSlideConfigurationScope,
    NxForm,
    NxFormColorPicker,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    anyBackgroundIsVideo() {
      if (!this.$refs.form || !this.$refs.form.draft) {
        return false;
      }
      if (!this.$refs.form.draft.multimediaDesktopImage && !this.$refs.form.draft.multimediaMobileImage) {
        return false;
      }
      return this.$refs.form.draft.multimediaDesktopImage.mimeType.includes('video')
        || this.$refs.form.draft.multimediaMobileImage.mimeType.includes('video');
    },
  },
  methods: {
    updateOnSelection() {
      if (this.$refs.form.draft
        && this.$refs.form.draft.multimediaDesktopImage
        && this.$refs.form.draft.multimediaDesktopImage.mimeType.includes('video')
      ) {
        this.$refs.form.updateField('videoLoop', true);
      }
      if (this.$refs.form.draft
        && this.$refs.form.draft.multimediaMobileImage
        && this.$refs.form.draft.multimediaMobileImage.mimeType.includes('video')
      ) {
        this.$refs.form.updateField('videoLoop', true);
      }
    },
  },
};
</script>
